/**
 * Client accessors for the demo-venue staff surface (tasks/demo-environment.md). Every call funnels
 * through `@repo/api-client`'s fetch mutator (bearer token, RFC 9457 `ApiError`, auto Idempotency-Key on
 * writes). Shapes are declared locally until the OpenAPI-generated models land (`just gen`); field names
 * mirror the backend `DemoContextController` / `DemoOperatorController` DTOs exactly, so the swap to the
 * generated types is a type-import change and nothing more.
 */
import { customInstance } from "@repo/api-client";

export type DemoContext = { isDemo: boolean };

export type DemoResetResponse = {
  outcome: "RESET" | "SKIPPED_ACTIVE_SESSION";
  venueId: string;
  rowsErased: number;
  rowsReseeded: number;
};

const venueBase = (venueId: string) => `/api/v1/venues/${encodeURIComponent(venueId)}`;

export const demoApi = {
  /** Whether the venue is a sales demo venue — the bootstrap flag the persistent DEMO banner reads. */
  context: (venueId: string, signal?: AbortSignal) =>
    customInstance<DemoContext>(`${venueBase(venueId)}/demo-context`, { method: "GET", signal }),

  /** Destroy-and-reseed the demo venue to its baseline (platform-operator gated; 403 otherwise). */
  reset: (venueId: string) =>
    customInstance<DemoResetResponse>(
      `/api/v1/internal/demo/${encodeURIComponent(venueId)}/reset`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: "{}",
      },
    ),
};
